
export default app => {
  app.config.globalProperties.$env = {
    VUE_APP_WEB_ENDPOINT: process.env.VUE_APP_WEB_ENDPOINT,
    VUE_APP_API_ENDPOINT: process.env.VUE_APP_API_ENDPOINT
  }
}
